import {
  Modal,
  Button,
  Typography,
  useTable,
  Tabs,
  Descriptions,
  Icons,
  useModal,
  DateField,
  Tag,
  Space,
  Table,
  Row,
  Icon,
} from '@pankod/refine-antd'
import { TimePicker, DatePicker } from 'antd'
import RangeValue from '../../../node_modules/rc-picker/lib/interface'
import dayjs from 'dayjs'
import moment from 'moment'
import { Data } from 'react-csv/components/CommonPropTypes'
import { CSVLink } from 'react-csv'
import { IPaperUsageAnalysis } from 'interfaces'
import { useState, useEffect } from 'react'

type paperUsageAnalysisProps = {
  paperId: string | undefined
}

export const PaperUsageAnalysis: React.FC<paperUsageAnalysisProps> = ({ paperId }) => {
  const [paperDataArr, setPaperDataArr] = useState<IPaperUsageAnalysis[]>()
  const [datePeriod, setDatePeriod] = useState<RangeValue.RangeValue<moment.Moment> | undefined>()
  const [exportData, setExportData] = useState<string | Data | (() => string | Data)>('')
  const [exportDataLoading, setExportDataLoading] = useState<boolean>(true)

  const { close: closePaperUsageModal, modalProps: paperUsageModalProps, show: showPaperUsageModal } = useModal()
  const { tableQueryResult: paperUsageQueryResult } = useTable<IPaperUsageAnalysis>({
    resource: 'paper_usage_analysis',
    metaData: { fields: ['id', 'paper_id', 'start_time', 'end_time', 'date', { test_event: ['id', 'name'] }] },
    permanentFilter: [{ field: 'paper_id', operator: 'eq', value: paperId }],
    queryOptions: { enabled: !!paperId },
  })
  const paperUsageData = paperUsageQueryResult?.data?.data

  const fetchData = () => {
    let data = ''
    data = data.concat('Test Event Usage, Name, Date\n')
    paperDataArr?.forEach((paperData, idx) => {
      const formattedDate = dayjs(paperData?.date).format('DD MMMM YYYY')
      data = data.concat(`${idx + 1}, ${paperData?.test_event?.name}, ${formattedDate}\n`)
    })

    setExportData(data)
    setExportDataLoading(false)
  }

  useEffect(() => {
    if (paperDataArr !== undefined) {
      fetchData()
    }
  }, [paperUsageData, paperDataArr])

  useEffect(() => {
    if (paperUsageData !== undefined) {
      setPaperDataArr(paperUsageData)
    }
  }, [paperUsageData])

  return (
    <>
      <Button
        key="paper_usage"
        onClick={() => {
          showPaperUsageModal()
        }}
        icon={<Icons.FileSearchOutlined />}
      >
        Usage Analysis
      </Button>
      <Modal
        {...paperUsageModalProps}
        title="Paper Usage Report"
        width={1000}
        footer={
          <Space>
            <Button type="default" key="export_paper_usage">
              {exportDataLoading ? (
                'Loading..'
              ) : (
                <CSVLink key="export" data={exportData} filename={`Paper_Usage_Analysis_${paperId}_${Math.round(new Date().getTime() / 1000)}`}>
                  <Space>
                    <Icons.ExportOutlined />
                    Export
                  </Space>
                </CSVLink>
              )}
            </Button>

            <Button
              onClick={() => {
                closePaperUsageModal()
              }}
            >
              Close
            </Button>
          </Space>
        }
      >
        <Space style={{ marginBottom: '10px' }}>
          <DatePicker.RangePicker
            value={datePeriod}
            renderExtraFooter={() => <Typography.Text strong>Select Time Period</Typography.Text>}
            onChange={value => {
              setDatePeriod(value)
              console.log('datepicker', value, !!value)
            }}
          />
          <Button
            disabled={!!!datePeriod}
            type="primary"
            onClick={() => {
              //use date period to filter
              if (!!datePeriod) {
                const filterStartDate = datePeriod[0]?.toISOString()
                const filterEndDate = datePeriod[1]?.toISOString()
                const filteredData = paperUsageData?.filter(paperData => {
                  const isBeforeDateValid = dayjs(paperData?.date).isBefore(dayjs(filterEndDate), 'day') // is before end date ?
                  const isAfterDateValid = dayjs(paperData?.date).isAfter(dayjs(filterStartDate), 'day') // is after start date ?
                  return isBeforeDateValid && isAfterDateValid
                })
                setPaperDataArr(filteredData)
              }
            }}
          >
            Set Period
          </Button>
          <Button
            disabled={!!!datePeriod}
            onClick={() => {
              setDatePeriod(null)
              paperUsageData !== undefined && setPaperDataArr(paperUsageData)
            }}
          >
            Reset
          </Button>
        </Space>

        <Table dataSource={paperDataArr} bordered title={() => <Typography.Text>Paper Usage Details</Typography.Text>}>
          <Table.Column
            title="Test Event"
            key="test_event"
            render={(_, record: any) => {
              return <Typography.Text>{record?.test_event?.name}</Typography.Text>
            }}
          />
          <Table.Column
            title="Slot Details"
            key="slot_details"
            render={(_, record: any) => {
              return (
                <Space>
                  <Tag>
                    <DateField value={record?.date} format="LL" />
                  </Tag>
                  <Tag>
                    <DateField value={record?.start_time} format="LT" />
                    <span>To</span>
                    <DateField value={record?.end_time} format="LT" />
                  </Tag>
                </Space>
              )
            }}
          />
        </Table>
      </Modal>
    </>
  )
}
